import axios from '@/axios'

const state = {
  loading: false,
  error: null,
  qrCode: null,
  isSetupMode: false,
  setupStep: 'qr',
  canShowQR: false
}

const getters = {
  loading: state => state.loading,
  error: state => state.error,
  qrCode: state => state.qrCode,
  isSetupMode: state => state.isSetupMode,
  setupStep: state => state.setupStep,
  canShowQR: state => state.canShowQR
}

const mutations = {
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  SET_ERROR(state, error) {
    state.error = error
  },
  SET_QR_CODE(state, qrCode) {
    state.qrCode = qrCode
  },
  SET_SETUP_MODE(state, isSetupMode) {
    state.isSetupMode = isSetupMode
  },
  SET_SETUP_STEP(state, step) {
    state.setupStep = step
  },
  SET_CAN_SHOW_QR(state, canShowQR) {
    state.canShowQR = canShowQR
  }
}

const actions = {
  async setup2FA({ commit }) {
    try {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      commit('SET_SETUP_MODE', true)
      commit('SET_SETUP_STEP', 'qr')

      const response = await axios.get(process.env.VUE_APP_API + 'user/2fa-setup')

      if (response.data && response.data.status === 'OK') {
        commit('SET_QR_CODE', response.data.qr)
        return { success: true }
      } else {
        commit('SET_ERROR', response.data?.message || 'Failed to generate QR code')
        return { success: false, error: response.data?.message || 'Failed to generate QR code' }
      }
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Failed to setup 2FA')
      return { success: false, error: error.response?.data?.message || 'Failed to setup 2FA' }
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async toggle2FA({ commit }, { code, enable }) {
    try {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)

      const payload = { code, enable }

      const response = await axios.post(process.env.VUE_APP_API + 'user/2fa-toggle', payload, {
        withCredentials: true,
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }
      })

      if (response.data && response.data.status === 'OK') {
        return { success: true }
      } else {
        const errorMessage = response.data?.message || 'Failed to toggle 2FA'
        commit('SET_ERROR', errorMessage)
        return Promise.reject(new Error(errorMessage))
      }
    } catch (error) {
      console.error('2FA toggle error:', error)
      const errorMessage = error.response?.data?.message || 'Failed to toggle 2FA'
      commit('SET_ERROR', errorMessage)

      return Promise.reject(error)
    } finally {
      commit('SET_LOADING', false)
    }
  },

  resetSetup({ commit }) {
    commit('SET_SETUP_MODE', false)
    commit('SET_SETUP_STEP', 'qr')
    commit('SET_QR_CODE', null)
    commit('SET_ERROR', null)
  },

  clearError({ commit }) {
    commit('SET_ERROR', null)
  },

  logout({ commit }) {
    commit('SET_LOADING', false)
    commit('SET_ERROR', null)
    commit('SET_QR_CODE', null)
    commit('SET_SETUP_MODE', false)
    commit('SET_SETUP_STEP', 'qr')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}